export function getReviewsNumber(reviewsCount?: string | null) {
  return reviewsCount ? parseInt(reviewsCount.replace(/^\D+/g, ''), 10) : 0;
}
